import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./auth/AuthContext";

export const PrivateRoute = () => {
  const { usuario, inicializando } = useAuth();

  if (inicializando) return null;
  if (!usuario) return <Navigate to="/" replace />;

  return <Outlet />;
};
